module.exports = __webpack_public_path__ + "img/4-star.fe7ce2ed.png";